module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "logo.6f29349e.webp";